
import { InterviewRequest, InterviewRequestResponse, SendRequestResult } from './types';
import { InterviewRequestsService } from './interviewRequestsService';

/**
 * Facade for interview requests operations
 */
export class InterviewRequestsFacade {
  /**
   * Send an interview request via email
   */
  static async sendInterviewRequest(requestData: InterviewRequest): Promise<SendRequestResult> {
    return InterviewRequestsService.sendInterviewRequest(requestData);
  }

  /**
   * Get an interview request by its link
   */
  static async getInterviewRequestByLink(requestLink: string): Promise<InterviewRequestResponse | null> {
    return InterviewRequestsService.getInterviewRequestByLink(requestLink);
  }

  /**
   * Get all interview requests
   */
  static async getAllInterviewRequests(): Promise<InterviewRequestResponse[]> {
    return InterviewRequestsService.getAllInterviewRequests();
  }

  /**
   * Delete an interview request by ID
   */
  static async deleteInterviewRequest(requestId: string): Promise<{ success: boolean; error?: string }> {
    return InterviewRequestsService.deleteInterviewRequest(requestId);
  }

  /**
   * Delete all interview requests
   */
  static async deleteAllInterviewRequests(): Promise<{ success: boolean; error?: string }> {
    return InterviewRequestsService.deleteAllInterviewRequests();
  }
}
